import { render, staticRenderFns } from "./SchoolRegister.vue?vue&type=template&id=787b7a78&"
import script from "./SchoolRegister.vue?vue&type=script&lang=js&"
export * from "./SchoolRegister.vue?vue&type=script&lang=js&"
import style0 from "./SchoolRegister.vue?vue&type=style&index=0&id=787b7a78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports